//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fillMeta } from '~/utils/seo';

export default {
  name: 'login',
  platforms: ['CARGO', 'CABINET'],
  access: '*',
  head () {
    return fillMeta({ title: this.title });
  },
  computed: {
    title () {
      return this.$t(`login.title`);
    },
  },
};
